import React, { useContext } from 'react';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import { AsDataGrid } from '@adserve/datagrid';
import { SpotGridColumnDefinitions } from './SpotGridColumnDefinitions';

const SpotsGrid = ({ data, campaignName }) => {
    const { dateFormat } = useContext(SystemSettingsContext);

    return (
        <div style={{ height: 40 * 13 + 37 }}>
            <AsDataGrid
                type='simple'
                multiSort
                data={data}
                columns={SpotGridColumnDefinitions(dateFormat)}
                downloadPdfButtonId={'pdf-format'}
                pdfFilename={`${campaignName} transmission times.pdf`}
                downloadExcelButtonId={'excel-format'}
                excelFilename={`${campaignName} transmission times.xlsx`}
                excelWorksheetName={'Transmission Times'}
            />
        </div>

    );
};

export default SpotsGrid;
